import { connect } from 'react-redux'
import NewBranchDialog from './NewBranchDialog'
import { createBranch } from './../../../store/branches/actions'

const mapStateToProps = (state, { currentBranchId }) => ({
  saving: state.loading[`creating-branch`],
})

const mapDispatchToProps = (dispatch, { currentBranchId, repositoryId }) => ({
  onCreateBranch: (branchName) => dispatch(createBranch(currentBranchId, branchName, repositoryId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewBranchDialog)


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/NewBranchDialog/Container.js